import { c as _c } from "react/compiler-runtime";
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
import type { AdvancedMentoringProductDTO } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { H4 } from '@/frontend/design-system/_marketing/typography/Heading/H4';
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph/P3';
import { Switch } from '@/frontend/design-system/forms/Switch';
type ApplicationHelpProps = {
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  updateProduct: (updates: (prev: AdvancedMentoringProductDTO) => Partial<AdvancedMentoringProductDTO>) => void;
};
export function ApplicationHelp(t0) {
  const $ = _c(9);
  const {
    advancedMentoringProduct,
    updateProduct
  } = t0;
  const applicationHelp = advancedMentoringProduct.applicationHelp;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H4>Aktywne wsparcie w poszukiwaniu możliwości</H4>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = applicationHelp === 1;
  let t3;
  if ($[1] !== updateProduct) {
    t3 = () => {
      updateProduct(_temp);
    };
    $[1] = updateProduct;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <div className="flex items-center justify-between">{t1}<Switch checked={t2} onChange={t3} /></div>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <P3>Mentor aktywnie szuka stypeniów, programów, staży i ofert pracy dostosowanych do Twoich potrzeb i aktualnego poziomu oraz aktywnie pomaga w aplikowaniu do nich.</P3>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <IconOnTheLeftWithContentLayout mainContent={t4}>{t5}</IconOnTheLeftWithContentLayout>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp(prev) {
  return {
    applicationHelp: prev.applicationHelp === 1 ? 0 : 1
  };
}